angular.module('utils').factory('tgUpload', function tgUploadFactory(tgField, $http) {
	function uploadFileFromFieldsToUrl(url, method, fields, data, successCallback, errorCallback) {
		data = angular.copy(data) //not to change the original data
		//Build Multipart form data for sending files + json data
		var boundary = 'AaB03x50046TagMe',
			contentType = 'multipart/form-data; boundary=' + boundary,
			body = '',
			fieldsArray
		if (_.isArray(fields)) fieldsArray = fields
		else fieldsArray = [fields]
		//Include Multipart files:
		for (var i in fieldsArray) {
			var field = fieldsArray[i]
			var file = _.get(data, field) //https://lodash.com/docs#get
			if (tgField.isImageDataString(file)) {
				//Parse file data:
				var fileName
				var fileType
				var fileBase64
				var temp = file.split(';')
				fileType = temp[0].split(':')[1]
				if (temp.length === 3) {
					fileName = temp[1].split(':')[1]
					fileBase64 = temp[2].split(',')[1]
				} else {
					fileName = 'new file.' + fileType.split('/')[1]
					fileBase64 = temp[1].split(',')[1]
				}
				_.set(data, field, fileName) //https://lodash.com/docs#set
				body += '--' + boundary + '\r\n'
				body += 'Content-Disposition: file; name="' + field + '"; filename="' + fileName + '"\r\n'
				body += 'Content-Type:' + fileType + '\r\n'
				body += 'Content-Transfer-Encoding: base64' + '\r\n\r\n' + fileBase64 + '\r\n'
			}
		}
		//Include Multipart json data
		body += '--' + boundary + '\r\n'
		body += 'Content-Disposition: form-data; name="formData"\r\n\r\n' + JSON.stringify(data) + '\r\n'
		//Multipart form data trailer
		body += '--' + boundary + '--'
		return $http({
			url: url,
			method: method,
			headers: {
				'Content-Type': contentType,
			},
			data: body
		})
			.then(function (response) {
				if (response.status == 200) {
					successCallback(response.data)
				} else {
					errorCallback(response)
				}
			})
			.catch(function (response) {
				errorCallback(response)
			})
	}

	return uploadFileFromFieldsToUrl
})
